<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
  <div class="row">
    <div class="col-sm" style="height: 10px;"></div>
    <div class="col-md" style="height: 20px"></div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb" class="bread-styles">
          <ol class="breadcrumb bd-background">
            <li class="breadcrumb-item active" aria-current="page">
                <a routerLink="#"><i class="fa fa-home" aria-hidden="true"></i></a> &nbsp;  > &nbsp;
              <a style="color: #6c757d;text-decoration: none;"> Manage Leads > <span style="color: #337ab7;font-family: 'pt_sans_captionbold';">  Add Leads</span></a>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row">
      <div class="col-sm" style="height: 10px;"></div>
      <div class="col-md" style="height: 20px"></div>
    </div>

    <div class="pie-charts">
        
      <h4 style="text-align: center;"> CREATE LEAD </h4>
      <hr>

      <form role="form" class="form-styles" #myForm="ngForm">
        <div class="form-group">
          <div class="form-row">
            <div class="col-md-6">
              <label>User Name <sup class="error">*</sup></label>
              <input type="text" name="username" data-toggle="tooltip" id="username"
                class="form-control input-md floatlabel" placeholder="Enter User Name" autofocus="on" autocomplete="off"
                maxlength="60" [(ngModel)]="username" />
            </div>
            <div class="col-md-6">
              <div class="form-group"> 
                <label for="dropdown">Referred By</label>
                <select name="userType" [(ngModel)]="role" id="userType" class="form-control" autofocus="on"
                  autocomplete="off" tabindex="3" placeholder="Choose" >
                  <option [ngValue]="undefined" hidden>---------------Choose User -------------</option>
                  <option [value]="a.user_id" *ngFor="let a of dropdown">{{a.display_email}}</option>
                </select>
              </div>
            </div>
          </div>
          <br>
          <div class="form-group">
            <div class="form-row">
              <div class="col-md-6">
                <label for="email">Email <sup class="error">*</sup></label>
                <input type="email" placeholder="Enter Email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                  class="form-control" id="email" name="email" ngModel #emailref="ngModel" [(ngModel)]="email">
                <div *ngIf="emailref.errors &&(emailref.touched || emailref.dirty)" class="alert alert-danger">
                  <div [hidden]="!emailref.errors?.pattern">
                    Invalid pattern
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label>Mobile<sup class="error">*</sup></label>
                <input type="mobile" name="mobile" id="cpassword" class="form-control input-md floatlabel"
                  placeholder="Enter Mobile" autofocus="on" autocomplete="off" maxlength="60" tabIndex="6"
                  [(ngModel)]="mobile" ngModel #cnfref="ngModel" />
                <div *ngIf="cnfref.errors &&(cnfref.touched || cnfref.dirty)" class="alert alert-danger">
                  <div [hidden]="!cnfref.errors?.pattern">
                    One Capital, one Small , One Number , Min 8 Charecters
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br>

          <div class="form-group">
            <div class="form-row">
              <div class="col-md-6">
                <label for="email">DataFrom <sup class="error">*</sup></label>
                <input type="text" placeholder="Enter DataFrom" class="form-control" id="datafrom" name="datafrom"
                  ngModel #emailref="ngModel" [(ngModel)]="datafrom">
                <div *ngIf="emailref.errors &&(emailref.touched || emailref.dirty)" class="alert alert-danger">
                  <div [hidden]="!emailref.errors?.pattern">
                    Invalid pattern
                  </div>
                </div>
              </div>
              <div class="col-md-6">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 30px"></div>
          </div>

          <div class="form-group">
            <div class="form-row" style="float: right;">
              <div class="col-md">
                <input type="submit" name="submit" id="submit" class="btn btn-danger btn-block" tabIndex="9"
                  value="Submit" (click)="submit()">
              </div>
              <div class="col-md">
                <input type="submit" name="submit" id="submit" class="btn btn-secondary btn-block" tabIndex="9"
                  value="Reset" (click)="reset()">
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

</section>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Loading </p>
</ngx-spinner>